import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Ключ пропуска ГЕНЕРАЦИИ — индекс урока С НУЛЯ, тот же, что в
 * `result.lessons` (§2). Человеку он показывается с единицы: ровно так
 * нумерует уроки лента чата («Пишу контент уроков 1-3 из 3»), и две
 * нумерации в одном экране читались бы как расхождение.
 *
 * Свой словарь, а не блочный: у генерации ключ — порядковый номер, а не
 * id сущности, и «Блок #1» соврал бы про суть пропуска.
 *
 * Незнакомый ключ отдаётся как есть — то же правило, что у
 * `imageTargetLabel`: формат ключей задаёт бэк, и молчаливая пустая
 * строка хуже сырого ключа. Регулярка отсекает пустую строку и минус
 * (`Number('')` это 0, и вышел бы «Урок 1» на пустом ключе), а
 * `Number.isInteger` остаётся страховкой от `Infinity` — строка из
 * трёхсот с лишним цифр регулярку проходит, а числом уже не станет.
 */
export const lessonTargetLabel = (key: string): string => {
  const index = Number(key)
  return /^\d+$/.test(key) && Number.isInteger(index)
    ? messagesNow(messages).targetLessonNumber(index + 1)
    : key
}
